import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Typography, Box, CircularProgress, Alert, Tooltip, Button, IconButton } from "@mui/material";
import { API_ENDPOINTS } from "../config/api.config";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export default function Activities() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
  });

  // Stati per funzionalità CRUD (temporaneamente disabilitate)

  // Fetch activities
  const fetchActivities = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(API_ENDPOINTS.ACTIVITIES);
      if (!response.ok) throw new Error("Error fetching activities");
      const data = await response.json();
      const activities = data.activities || data || [];
      console.log('Activities loaded:', activities);
      setRows(activities.map((row, idx) => ({ id: row.id || idx, ...row })));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActivities();
  }, []);

  // Colonne della tabella
  const columns = [
    {
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <Tooltip title="Edit (Disabled)">
            <span>
              <IconButton disabled size="small">
                <EditIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Delete (Disabled)">
            <span>
              <IconButton disabled size="small">
                <DeleteIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      )
    },
    { field: 'id', headerName: 'ID', width: 80 },
    { field: 'name', headerName: 'Name', width: 250, flex: 1 },
    { field: 'description', headerName: 'Description', width: 400, flex: 1 },
  ];

  // Funzionalità CRUD disabilitate temporaneamente

  return (
    <Box>
      <Box my={4}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h4" gutterBottom sx={{ fontSize: '1.5rem' }}>
            Activities Management
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            color="primary"
            disabled
            title="Add Activity (Disabled)"
          >
            Add Activity
          </Button>
        </Box>
        
        {loading ? (
          <CircularProgress />
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <Box sx={{ height: 600, width: '100%' }}>
            <DataGrid
              rows={rows}
              columns={columns}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              pageSizeOptions={[5, 10, 25, 50, 100]}
              pagination
              hideFooter={false}
              sx={{ bgcolor: 'white' }}
              disableSelectionOnClick
            />
          </Box>
        )}
      </Box>

      {/* Dialog disabilitato - funzionalità temporaneamente non disponibile */}
    </Box>
  );
}
